<template>
  <div class="layout" :id="layoutId">
    <!-- 上部区域，固定不动 -->
    <div class="header">
      <slot name="header"></slot>
    </div>

    <!-- 中间区域，内容可以滚动 -->
    <div class="content" ref="contentArea" @scroll="handleScroll">
      <slot name="content"></slot>
    </div>

    <!-- 下部区域，固定不动 -->
    <div class="footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ThreeSectionLayout",
  props: {
    layoutId: {
      type: String,
      required: true, // 每个实例必须有唯一的 ID 传递进来
    },
  },
  methods: {
    handleScroll() {
      const element = this.$refs.contentArea;
      const scrollTop = element.scrollTop;
      const scrollHeight = element.scrollHeight;
      const clientHeight = element.clientHeight;

      // 判断是否滚动到了顶部
      if (scrollTop === 0) {
        this.$emit("scroll-top", this.layoutId); // 向父组件发送滚动到顶部的事件
      }
      // 判断是否滚动到了底部
      if (scrollTop + clientHeight >= scrollHeight) {
        this.$emit("scroll-bottom", this.layoutId); // 向父组件发送滚动到底部的事件
      }
    },
  },
};
</script>

<style scoped>
.layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100%;
  min-height: 100%; /* 防止内容不足时高度塌陷 */
}

.header {
  flex-shrink: 0;
}

.content {
  overflow-y: auto;
  flex: 1 1 auto; /* 关键：允许内容区域伸缩 */
  min-height: 0; /* 修复 flex 容器滚动问题 */
}

.footer {
  flex-shrink: 0;
}
</style>
